import usePopup, {CardDeletePopupProps} from '@/root/hooks/usePopup';

import Popup from '@/shared/components/Popup/Layout';
import {TIARA_ACTION} from '@/shared/constants/tiara';
import useHistoryBackAOS from '@/shared/hooks/useHistoryBackAOS';

const CardDeletePopup = ({onSubmit, selectedCardCount}: CardDeletePopupProps) => {
  const {closePopup} = usePopup();

  const onConfirm = () => {
    onSubmit();
    closePopup();
  };

  useHistoryBackAOS(closePopup);

  return (
    <Popup>
      <Popup.Title>디지털카드를 삭제하시겠습니까?</Popup.Title>
      <Popup.Content>
        {selectedCardCount}개의 디지털카드를 삭제합니다.
        <br />
        디지털카드에 저장된 정보가 삭제되며 복구할 수 없습니다.
      </Popup.Content>
      <Popup.GroupButton>
        <button
          type="button"
          className="btn btn_gray"
          data-tiara-action-name={TIARA_ACTION.CANCEL_CLICK}
          onClick={closePopup}
        >
          취소
        </button>
        <button
          type="button"
          className="btn btn_gray"
          data-tiara-action-name={TIARA_ACTION.CONFIRM_CLICK}
          onClick={onConfirm}
        >
          확인
        </button>
      </Popup.GroupButton>
    </Popup>
  );
};

export default CardDeletePopup;
